import { render, staticRenderFns } from "./validateModal.vue?vue&type=template&id=6c56ee25&"
import script from "./validateModal.vue?vue&type=script&lang=js&"
export * from "./validateModal.vue?vue&type=script&lang=js&"
import style0 from "./validateModal.vue?vue&type=style&index=0&id=6c56ee25&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports